import React, { useCallback } from 'react';
import { ButtonSendWhatsApp } from 'components/dialog-patient/components';
import { SupportMeeting } from 'services/support-meetings';
import { UserPatientProfile } from 'services/user-patient-profile';
import { useAppDispatch } from 'store';
import { actionSupportMeetingActivitiesCrateLogSendWhatsApp } from 'store/support-meeting-activities/actions';

interface Props {
  userPatientProfileID: string;
  supportMeetingID: string;
  patient: Pick<UserPatientProfile, 'mobilePhone' | 'firstName' | 'lastName'> | null;
  meeting: Pick<SupportMeeting, 'meetingFromDateTime' | 'meetingToDateTime'> | null;
}
export const ButtonWhatsApp: React.FC<React.PropsWithChildren<Props>> = ({
  userPatientProfileID,
  patient,
  meeting,
  supportMeetingID,
}) => {
  const dispatch = useAppDispatch();

  const onSendDone = useCallback(() => {
    dispatch(
      actionSupportMeetingActivitiesCrateLogSendWhatsApp({
        supportMeetingID,
      }),
    );
  }, [dispatch, supportMeetingID]);

  return (
    <ButtonSendWhatsApp
      userPatientProfileID={userPatientProfileID}
      toPhoneNumber={patient?.mobilePhone}
      patient={patient ?? {}}
      meeting={meeting ?? null}
      fullWidth
      onDone={onSendDone}
    />
  );
};
